const Icon = ({ 
  name, 
  size = 20, 
  color = 'currentColor', 
  className = '', 
  alt = '',
  ...props 
}) => {
  const getIconPath = (iconName) => {
    const icons = {
      // Contact Icons
      'contact': '../assets/contact-image.png',
      'edit': '../assets/edit-contact-icon.png',
      'email': '../assets/email-icon.png',
      'phone': '../assets/phone-icon.png',
      'address': '../assets/phone-icon.png',
      'timezone': '../assets/phone-icon.png',
      
      // Metric Icons
      'total-donors': '../assets/total-donors.png',
      'total-income': '../assets/Total-Income.png',
      'total-mailed': '../assets/Total-mailed.png',
      'average-gift': '../assets/Average-gift.png',
      
      // Profile Icons
      'user-profile': '../assets/user-profile.png',
      
      // UI Icons
      'fold': '../assets/sidebar-fold-icon.png',

      //active icon
      'active': '../assets/active-icon.png',
      // inactive icon
      'in-active':'../assets/In-active-icon.png',

      //search icon
      'search': '../assets/search-icon.png',

      //location icon
      'location' : '../assets/location-icon.png',

      //postal information icon
      'postal' : '../assets/postal-information-icon.png',

      //physical mailing address
      'physical-mailing-address' : "../assets/physical-mailing-addess.png",

      //timezone

      'timezone': "../assets/timezone.png",

      //three-dot

      'action' : "../assets/three-dot.png",

      //eye-on-icon
      
      'eye-on-icon': "../assets/eye-on-icon.png",

      //expandopen

      'expand-open': "../assets/expand-open.png",

      //expand closed

      'expand-closed' : "../assets/expand-closed.png",

      //fie icon

      'file-icon' : "../assets/file-icon.png",

      //list summary icon

      'list-summary-icon' : "../assets/list-summary-icon.png",

      //dollar icon

      'dollar-icon' : "../assets/dollar-icon.png",

      //files icon

      'files-icon' : "../assets/files-icon.png",

      //Mail Icon

      'mail-icon' :"../assets/mail-icon.png",

      //pending Icon

      'pending-icon': "../assets/pending-icon.png",

      //Successful Icon

      'successful-icon' : "../assets/successful-icon.png",

      //EYE

      'eye' : "../assets/eye.png",


      //Success icon

      'success-icon' : "../assets/success-icon.png",

      //Warning Icon

      'warning-icon' : "../assets/warning.png",

      //Package Icon

      'package-icon' :  "../assets/package-icon.png",

      // Error Icon

      'error-icon' : "../assets/error-icon.png",

      //up ward arrow icon

      'upward-arrow-icon' : "../assets/upward-arrow-icon.png",

      //user icon

      'user-icon' : "../assets/user-icon.png",

      //ais-loader

      'ais-loader' : "../assets/rockwell_solutions_loader-data.gif",

      'camera-icon' : "../assets/camera-icon.png",

      'settings-icon-reports' : "../assets/settings-icon-reports.png"

    };

    return icons[iconName] || '../assets/contact-image.png';
  };

  return (
    <img
      src={getIconPath(name)}
      alt={alt || `${name} icon`}
      width={size}
      height={size}
      className={`icon ${className}`}
      style={{ 
        color: color,
        display: 'inline-block',
        verticalAlign: 'middle'
      }}
      {...props}
    />
  );
};

export default Icon;